import { Box, Card, CardContent, CardMedia, Stack, Typography } from '@mui/material';
import React from 'react';

import IMG1 from '../../../assets/Landing/img1.png';
import IMG2 from '../../../assets/Landing/img2.png';

const MainBanner = () => {
  return (
    <Stack spacing={5} direction={'column'} sx={{ alignItems: 'center', width: '100%' }}>
      <Typography textTransform={'capitalize'} textAlign={'center'} variant="h2" fontWeight={800} fontFamily={'montserrat'} color='#1C486A'>
        OUR SERVICES
      </Typography>

      {/* Outer Stack for the Cards */}
      <Stack
        spacing={5}
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={'center'}
        justifyContent={'center'}
        sx={{ maxWidth: '1200px', mx: 'auto', paddingX: '24px' }}
      >
        {/* First Card - Online Bookkeeping Services */}
        <Card sx={cardStyles}>
          <CardMedia component="img" sx={cardMediaStyles} image={IMG1} alt="Online Bookkeeping Services" />
          <Box sx={boxStyles}>
            <CardContent>
              <Typography variant="body1">
                Stay ahead of your financial management with our comprehensive online bookkeeping services, meticulously designed to keep your records accurate and up-to-date. Our services include Accounts Receivable & Payable, Bank Reconciliations, Balance Sheet Transactions, and more. Whether manual or cloud-based, we ensure your financial data is expertly managed.
              </Typography>
            </CardContent>
            <Typography variant="h6" sx={typographyStyles}>
              Online Bookkeeping Services
            </Typography>
          </Box>
        </Card>

        {/* Second Card - ICT Services */}
        <Card sx={cardStyles}>
          <CardMedia component="img" sx={cardMediaStyles} image={IMG2} alt="ICT Services" />
          <Box sx={boxStyles}>
            <CardContent>
              <Typography variant="body1">
                Elevate your business with our cutting-edge ICT solutions, designed to empower and transform your technology infrastructure. Our services include Software Development, Mobile App Development, Data Analytics, Automation, Digital Marketing, and more, all tailored to your specific needs.
              </Typography>
            </CardContent>
            <br/>
            <br/>
            <Typography variant="h6" sx={typographyStyles}>
              ICT Services
            </Typography>
          </Box>
        </Card>
      </Stack>

      {/* Additional Cards */}
      <Stack spacing={5} direction={{ xs: 'column', sm: 'row' }} alignItems={'center'} justifyContent={'center'} sx={{ maxWidth: '1200px', mx: 'auto', paddingX: '24px' }}>
        {/* Comprehensive Tax Solutions */}
        <Card sx={cardStyles}>
          <CardMedia component="img" sx={cardMediaStyles} image={IMG1} alt="Comprehensive Tax Solutions" />
          <Box sx={boxStyles}>
            <CardContent>
              <Typography variant="body1">
                Effortlessly navigate the complexities of taxation with our expert solutions, tailored for Sri Lankan clients. Our services include Tax Consultation, Corporate & Personal Tax Calculations, VAT Registration, and more.
              </Typography>
            </CardContent>
            <Typography variant="h6" sx={typographyStyles}>
              Comprehensive Tax Solutions
            </Typography>
          </Box>
        </Card>

        {/* Business Registration */}
        <Card sx={cardStyles}>
          <CardMedia component="img" sx={cardMediaStyles} image={IMG2} alt="Business Registration" />
          <Box sx={boxStyles}>
            <CardContent>
              <Typography variant="body1">
                Launch your business with ease through our comprehensive registration services. We have a proven track record of registering over 100 businesses globally, ensuring your success in local and international markets.
              </Typography>
            </CardContent>
            <Typography variant="h6" sx={typographyStyles}>
              Business Registration
            </Typography>
          </Box>
        </Card>
      </Stack>

      <Stack spacing={5} direction={{ xs: 'column', sm: 'row' }} alignItems={'center'} justifyContent={'center'} sx={{ maxWidth: '1200px', mx: 'auto', paddingX: '24px' }}>
        {/* Company Secretarial Services */}
        <Card sx={cardStyles}>
          <CardMedia component="img" sx={cardMediaStyles} image={IMG1} alt="Company Secretarial Services" />
          <Box sx={boxStyles}>
            <CardContent>
              <Typography variant="body1">
                Keep your Sri Lankan business compliant and well-governed with our expert secretarial services. We manage your statutory records, filings, and governance requirements, ensuring your company remains in good legal standing.
              </Typography>
            </CardContent>
            <Typography variant="h6" sx={typographyStyles}>
              Company Secretarial Services
            </Typography>
          </Box>
        </Card>

        {/* Audit Services */}
        <Card sx={cardStyles}>
          <CardMedia component="img" sx={cardMediaStyles} image={IMG2} alt="Audit Services" />
          <Box sx={boxStyles}>
            <CardContent>
              <Typography variant="body1">
                Strengthen your financial integrity with our rigorous audit services, designed exclusively for Sri Lankan businesses. We conduct external and internal audits, ensuring your financial records are accurate and fully compliant.
              </Typography>
            </CardContent>
            <Typography variant="h6" sx={typographyStyles}>
              Audit Services
            </Typography>
          </Box>
        </Card>
      </Stack>

      <Stack spacing={5} direction={{ xs: 'column', sm: 'row' }} alignItems={'center'} justifyContent={'center'} sx={{ maxWidth: '1200px', mx: 'auto', paddingX: '24px' }}>
        {/* Legal Services */}
        <Card sx={cardStyles}>
          <CardMedia component="img" sx={cardMediaStyles} image={IMG1} alt="Legal Services" />
          <Box sx={boxStyles}>
            <CardContent>
              <Typography variant="body1">
                Safeguard your business with our specialized corporate legal services at KALEIDO International. We offer solutions for agreements, trademark registration, compliance, mergers, acquisitions, and more to ensure your business is legally protected.
              </Typography>
            </CardContent>
            <Typography variant="h6" sx={typographyStyles}>
              Legal Services
            </Typography>
          </Box>
        </Card>
      </Stack>
    </Stack>
  );
};

// Common styles for the cards, card media, box, and typography
const cardStyles = {
  width: { xs: '100%', sm: '950px' },
  display: 'flex',
  flexDirection: { xs: 'row', sm: 'row' },
  borderRadius: '12px',
  backgroundColor: '#335980',
  color: 'white',
  padding: '16px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  '&:hover': { transform: 'scale(1.05)', boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)' },
  flexWrap: { xs: 'wrap', sm: 'nowrap' }
};

const cardMediaStyles = {
  width: { xs: '100%', sm: 160 },
  borderRadius: '8px',
  mb: { xs: 2, sm: 0 }
};

const boxStyles = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  flexGrow: 1,
  marginLeft: { xs: 0, sm: '16px' },
  textAlign: { xs: 'center', sm: 'left' }
};

const typographyStyles = {
  marginTop: { xs: '16px', sm: 'auto' },
  fontWeight: 'bold',
  textAlign: 'center'
};

export default MainBanner;
